import { useQuery } from "@tanstack/react-query";
import { ProductService } from "../services/productService";

const useStats = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['stats'],
        queryFn: () => ProductService.getStats(),
    });

    return { data, isLoading, error };
};

export default useStats;
